(() => {
  if (window.kontentaProductCardFormReady) return;

  window.kontentaProductCardFormReady = true;

  function getVariants(form) {
    const script = form.querySelector('[data-product-card-variants]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Could not parse product card variants', error);
      return [];
    }
  }

  function getSelectedOptions(form) {
    const optionsPanel = form.querySelector('[data-product-card-options]:not([hidden])');
    if (!optionsPanel) return [];

    return Array.from(optionsPanel.querySelectorAll('fieldset')).map((fieldset) => {
      return {
        position: Number(fieldset.dataset.optionPosition) - 1,
        value: fieldset.querySelector('[data-product-card-option]:checked')?.value,
      };
    }).filter((option) => option.value && option.position >= 0);
  }

  function findSelectedVariant(form) {
    const selectedOptions = getSelectedOptions(form);
    const variants = getVariants(form);

    return variants.find((variant) => {
      return selectedOptions.every((option) => variant.options[option.position] === option.value);
    });
  }

  function updateOptionAvailability(form) {
    const variants = getVariants(form);
    const selectedOptions = getSelectedOptions(form);
    const optionsPanel = form.querySelector('[data-product-card-options]:not([hidden])');
    if (!optionsPanel) return;

    optionsPanel.querySelectorAll('[data-product-card-option]').forEach((input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      const label = optionsPanel.querySelector(`label[for="${input.id}"]`);

      const isAvailable = variants.some((variant) => {
        if (!variant.available || variant.options[position] !== input.value) return false;

        return selectedOptions.every((option) => {
          if (option.position === position) return true;
          return variant.options[option.position] === option.value;
        });
      });

      input.classList.toggle('disabled', !isAvailable);
      input.toggleAttribute('data-option-unavailable', !isAvailable);
      label?.classList.toggle('product-card-option-value--unavailable', !isAvailable);
    });
  }

  function syncLinkedVariants(form, productId) {
    if (!productId) return;

    const variantsScript = form.querySelector('[data-product-card-variants]');
    const linkedVariantsScript = form.querySelector(`[data-product-card-linked-variants][data-product-id="${productId}"]`);

    if (variantsScript && linkedVariantsScript) {
      variantsScript.textContent = linkedVariantsScript.textContent;
    }
  }

  function showLinkedOptionsPanel(form, productId) {
    if (!productId) return;

    form.querySelectorAll('[data-product-card-options][data-product-id]').forEach((panel) => {
      panel.hidden = panel.dataset.productId !== productId;
    });
  }

  function updateSubmitState(form, variant) {
    const variantInput = form.querySelector('[data-product-card-variant-id]');
    const submitButton = form.querySelector('[type="submit"]');
    const label = submitButton?.querySelector('.qa-label');

    if (!variantInput || !submitButton || !label) return;

    if (!variant) {
      variantInput.value = '';
      variantInput.disabled = true;
      submitButton.disabled = true;
      label.textContent = window.variantStrings?.unavailable || 'Unavailable';
      return;
    }

    variantInput.value = variant.id;
    variantInput.disabled = !variant.available;
    submitButton.disabled = !variant.available;
    label.textContent = variant.available
      ? window.variantStrings?.addToCart || 'Add to cart'
      : window.variantStrings?.soldOut || 'Sold out';
  }

  function updateCardImage(option) {
    const imageUrl = option.dataset.imageUrl;
    const hoverImageUrl = option.dataset.hoverImageUrl;
    if (!imageUrl && !hoverImageUrl) return;

    const card = option.closest('.card-product');
    if (!card) return;

    const imageSrcset = option.dataset.imageSrcset;
    const hoverImageSrcset = option.dataset.hoverImageSrcset;
    const defaultImages = card.querySelectorAll('.product-card-default-image img, .card-product--single-image-wrapper img');
    const revealImages = card.querySelectorAll('.product-card-reveal-image img');

    defaultImages.forEach((image) => {
      if (!imageUrl) return;
      image.src = imageUrl;

      if (imageSrcset) {
        image.srcset = imageSrcset;
      }
    });

    revealImages.forEach((image) => {
      const revealUrl = hoverImageUrl || imageUrl;
      const revealSrcset = hoverImageSrcset || imageSrcset;

      if (!revealUrl) return;
      image.src = revealUrl;

      if (revealSrcset) {
        image.srcset = revealSrcset;
      }
    });
  }

  function updateCardProduct(option) {
    const card = option.closest('.card-product');
    if (!card) return;

    const productUrl = option.dataset.productUrl;
    const productTitle = option.dataset.productTitle;
    const priceHtml = option.dataset.priceHtml;

    if (productUrl) {
      card.querySelectorAll('a[href]').forEach((link) => {
        link.href = productUrl;

        if (productTitle) {
          link.title = productTitle;
          link.setAttribute('aria-label', productTitle);
        }
      });
    }

    if (productTitle) {
      const title = card.querySelector('.card-product-title-h3');
      if (title) title.textContent = productTitle;
    }

    if (priceHtml) {
      const price = card.querySelector('.card-product--price');
      if (price) price.innerHTML = priceHtml;
    }
  }

  function updateLinkedVariantState(option) {
    const form = option.closest('form');
    if (!form) return;

    syncLinkedVariants(form, option.dataset.productId);
    showLinkedOptionsPanel(form, option.dataset.productId);
    updateOptionAvailability(form);
    updateCardImage(option);
    updateCardProduct(option);

    const selectedVariant = findSelectedVariant(form);

    updateSubmitState(form, {
      id: selectedVariant?.id || option.value,
      available: selectedVariant?.available ?? option.dataset.available === 'true',
    });
  }

  document.addEventListener('change', (event) => {
    const linkedOption = event.target.closest('[data-product-card-linked-variant]');
    if (linkedOption) {
      updateLinkedVariantState(linkedOption);
      return;
    }

    const option = event.target.closest('[data-product-card-option]');
    if (!option) return;

    const form = option.closest('form');
    if (!form) return;

    updateOptionAvailability(form);
    updateSubmitState(form, findSelectedVariant(form));
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-card-linked-variant]:checked').forEach(updateLinkedVariantState);
    document.querySelectorAll('.product-card-form__form').forEach(updateOptionAvailability);
  });
})();
